const getHeaderHeight = () => {
  const header = document.querySelector('[data-header-group]');
  const setHeaderHeight = () => {
    if (header) {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight * -1}px`);
    }
  };
  ['load', 'resize'].forEach(function (e) {
    window.addEventListener(e, setHeaderHeight);
  });
};

export default getHeaderHeight;
